import { EnvEnum } from '../../../types/enums.ts'

/**
 * "Encarga un coche" ya NO vive en este repo: es una aplicación aparte con su
 * propio despliegue y dominio (gamaoptima.net). Toda la navegación interna
 * (header, drawer, footer, tarjetas de CTA) debe apuntar aquí.
 *
 * La ruta antigua `app/routes/_guest+/encarga-un-coche/route.tsx` se conserva
 * sin uso y redirige a estas URLs. Ver el comentario de cabecera de ese fichero.
 */
const ENCARGA_UN_COCHE_URL = {
  production: 'https://gamaoptima.net/',
  nonProduction: 'https://staging.gamaoptima.net/',
} as const

/**
 * URL pública de la app de "Encarga un coche" según el entorno:
 * producción → gamaoptima.net, dev/staging → staging.gamaoptima.net.
 *
 * Funciona en cliente (`window.ENV`) y en servidor (`global.ENV`); si por lo
 * que sea `ENV` no estuviera disponible, cae en staging para no mandar tráfico
 * de pruebas a producción.
 */
export function getEncargaUnCocheUrl() {
  const mode = typeof ENV === 'undefined' ? undefined : ENV?.MODE

  return mode === EnvEnum.PRODUCTION
    ? ENCARGA_UN_COCHE_URL.production
    : ENCARGA_UN_COCHE_URL.nonProduction
}

/**
 * Props para abrir un enlace externo en una pestaña nueva de forma segura.
 */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const
